$(document).ready(function () {
    /*
    Infinite Scroll
     */
    $.fn.matchHeight._maintainScroll = true;
    var $nextLink = $('.pagination__next');
    if (!$nextLink.length) {
        $('.view-more-button').hide();
    }

    var infiniteIncrement = ($('.infinite-tiles').hasClass('infinite-tiles-industry')) ? $('.post').length : $('.post > div').length;

    var $container = $('.infinite-tiles').infiniteScroll({
        path: function () {
            if ($(this.element).hasClass('infinite-tiles-search')) {


                var pageNumber = (this.loadCount + 1) * 10;
                var query_search = $('input:hidden[name=query_search]').val();
                //var query_next = $('input:hidden[name=query_next]').val();
                var query_section = $('input:hidden[name=query_section]').val();


                return '/search/more/?q=' + query_search + '&start=' + pageNumber + '&section=' + query_section;
            } else {
                var pageNumber = (this.loadCount + 1) * infiniteIncrement;

                let pagination_url = $(this.element).find('.pagination__next');

                if (pagination_url.length > 0) {

                    if ($(this.element).hasClass('ip-cores-infinite')) {
                        var ip_core_params = {},
                            selected_language = $('input:hidden[name=selected_language]').val(),
                            selected_license = $('input:hidden[name=selected_license]').val(),
                            selected_version = $('input:hidden[name=selected_version]').val();

                        if (selected_language != "" && selected_language != "/") {
                            ip_core_params['language'] = selected_language;
                        }

                        if (selected_license != "" && selected_license != "/") {
                            ip_core_params['license'] = selected_license;
                        }

                        if (selected_version != "" && selected_version != "/") {
                            ip_core_params['version'] = selected_version;
                        }

                        /*
                            weird one off use case for ip-core pagination, these pagination urls dont have a trailing '/' as we would expect
                            Also they don't go to the pagination url link but rather a seperate url that was set up called ip-paginate
                            We also allowed for passing of params at the end of the pagination on ipcores pages
                         */
                        let pagination_array = pagination_url.attr('href').split('/');
                        pagination_array[pagination_array.length - 1] = 'ip-paginate/P' + pageNumber;
                        return pagination_array.join('/') + '/?' + $.param(ip_core_params);
                    } else {

                        /*
                            We assume that values in .pagination__next container are always of the form:
                            http://www.site.com/slug/.../P#/

                            Therefore when we split that url into an array by '/' we know that the 2nd last value
                            of the array will be the pagination slug 'P#'

                            We replace this pagination slug with infinite scrolls internal counter
                         */

                        let pagination_array = pagination_url.attr('href').split('/');
                        pagination_array[pagination_array.length - 2] = 'P' + pageNumber;
                        return pagination_array.join('/');
                    }
                }
            }
        },
        append: '.post',
        button: '.view-more-button',
        status: '.page-load-status',
        checkLastPage: '.pagination__next',
        history: false,
    });
    var infScroll = $container.data('infiniteScroll');
    $container.on('load.infiniteScroll', onPageLoad);

    function onPageLoad() {

        if ($('.sticky-container, .vertical-ad').css('position') == 'absolute') {
            $('.sticky-container, .vertical-ad').attr('style', 'position: fixed; top: 16px; width: 300px;');
        }
        if (infScroll.loadCount == 1) {
            if (typeof ga === 'function') {
                ga('send', 'event', 'load-more', 'lazyload', infScroll.getPath());
            }
            if (typeof gtag === 'function') {
                gtag("event", "lazyload", {
                    event_category: "load-more",
                    event_label: infScroll.getPath(),
                });
            }
            $container.infiniteScroll('option', {
                loadOnScroll: false,
            });
        } else {
            var $el = $(".post").last();
            var bottom = $el.offset().top + $el.outerHeight(true);

            $([document.documentElement, document.body]).animate({
                scrollTop: bottom
            }, 1000);
        }
    }

    $container.on('append.infiniteScroll', function () {
        $('main').removeAttr('style');
        setTimeout(function () {
            $('#wallpaper, .wp').matchHeight({
                target: $('main')
            });
        }, 500);
    });

});